import * as THREE from 'three';

export interface PerfProfileOptions {
  mobile: boolean;
  captureMode: boolean;
}

export function applyRendererPerfProfile(renderer: THREE.WebGLRenderer, opts: PerfProfileOptions): void {
  const dpr = opts.mobile
    ? Math.min(window.devicePixelRatio, 1)
    : Math.min(window.devicePixelRatio, 1.35);
  renderer.setPixelRatio(dpr);
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.setPixelRatio(dpr);
}

export function configureSunShadow(sun: THREE.DirectionalLight, mobile: boolean): void {
  const size = mobile ? 1024 : 1536;
  sun.shadow.mapSize.set(size, size);
  sun.shadow.camera.near = 6;
  sun.shadow.camera.far = 48;
}
